import { Component, OnInit, inject } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EventManager } from '@app/shared/utils/event-manager';
import { TestPanelAudioComponent } from '@app/audio/test-panel/test-panel-audio.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { ModalConfig, Modal, ModalType } from '@app/shared/models/modal.model';
import { SharedModule } from '@app/shared/shared.module';
import { environment } from '@environments/environment';
import { LogLevel } from '@app/shared/utils/logger/log-entry';

@Component({
  standalone: true,
  selector: 'slotcom-tester-web-options',
  imports: [ButtonComponent, SharedModule, FormsModule, ReactiveFormsModule, TestPanelAudioComponent],
  templateUrl: './web-options.component.html',
  styleUrls: ['../tester-modal.component.scss'],
})
export class WebOptionsComponent implements OnInit {
  testerModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private formBuilder = inject(FormBuilder);

  logLevelForm: FormGroup;

  protected readonly LogLevel = LogLevel;

  onSubmitLogLevel(): void {
    environment.logLevel = this.logLevelForm.value.selectedLogLevel;
    this.closeModal();
  }

  closeModal(): void {
    this.eventManager.closeModal(new Modal(this.testerModalData.id, ModalType.View, this.testerModalData));
  }

  ngOnInit(): void {
    this.logLevelForm = this.formBuilder.group({
      selectedLogLevel: [environment.logLevel],
    });
  }
}
